<template>
  <div class="all-question-outer">
    <div class="sign" v-if="questionData.data.is_sign == '1'">
      <img src="../../../../assets/cancelSign.png" alt="" />
      <span>已标记</span>
    </div>
    <div class="question" v-if="questionData.data.content">
      <div class="questionTop">
        <div class="title">
          「单选题」
          <span class="score" v-if="questionData.data.score">{{ questionData.data.score }}分</span>
          <span class="getScore" v-if="questionData.record_id">
            得分:{{
              questionData.data.user_log.score
                ? questionData.data.user_log.score
                : 0
            }}分
          </span>
        </div>
        <!-- 试题附件展示组件 -->
        <question-files v-if="questionData.data.attachment" :attachment="questionData.data.attachment"></question-files>
        <span class="questionName">{{ questionData.index + 1 }}、<span v-html="questionData.data.content"></span></span>
      </div>
      <ul class="radioContent">
        <a-radio-group v-model="value" disabled class="selete">
          <li v-for="(item, index) in questionData.data.items" :key="item.id">
            <a-radio :value="item.id">
              {{ String.fromCharCode(index + 65) }}、<span v-html="item.content"></span>
            </a-radio>
          </li>
        </a-radio-group>
      </ul>
      <div v-if="questionData.data" :class="
          questionData.data.user_log.is_right == '1' ? 'answer1' : 'answer2'
        ">
        <span>正确答案：{{ right }}</span>
        <span>你的答案：{{ questionData.data.user_log ? myAnswer : "未答" }}</span>
      </div>
      <div class="ansAnalysis">
        答案解析：
        <div v-html="
            questionData.data.correct_content
              ? questionData.data.correct_content
              : '无'
          "></div>
      </div>
    </div>
    <div class="question" v-else>
      <div class="questionTop">
        <span class="deleted">{{ questionData.index + 1 }}、此题已被删除</span>
      </div>
      <div class="deleteImg">
        <img src="@/assets/deleted.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import QuestionFiles from "../questionFiles.vue";
export default {
  name: "radio",
  props: ["questionData"],
  components: { QuestionFiles },
  data () {
    return {
      value: this.questionData.data.user_log
        ? Number(this.questionData.data.user_log.answer)
        : "",
      right: "",
      myAnswer: "",
    };
  },
  mounted () {
    let str1 = "";
    this.questionData.data && this.questionData.data.items && this.questionData.data.items.forEach(function (item, index) {
      if (item.is_right == "1") {
        str1 = String.fromCharCode(index + 65);
      }
    });
    this.right = str1;
    let str2 = "";
    if (this.questionData.data && this.questionData.data.user_log && this.questionData.data.user_log.answer) {
      this.questionData.data.items.map((item, index) => {
        if (item.id == this.questionData.data.user_log.answer) {
          str2 = String.fromCharCode(index + 65);
        }
      });
    } else {
      str2 = "无";
    }

    this.myAnswer = str2;
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.all-question-outer {
  width: 100%;
  height: calc(100% - 60px);
  padding: 20px 50px 30px 50px;
  position: relative;
}
.sign {
  height: 32px;
  position: absolute;
  top: 35px;
  right: 50px;
  text-align: right;
  color: #f79e3f;
}
.sign img {
  width: 30px;
  height: auto;
  margin-right: 4px;
  display: inline-block;
}
.sign span {
  line-height: 32px;
}
.question .title {
  width: 371px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 32px;
}
.question .questionName {
  width: 92px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #14202c;
  line-height: 32px;
  word-wrap: break-word;
  word-break: normal;
}
.questionTop {
  padding: 15px 0 0;
  /deep/img {
    display: block;
    max-width: 100%;
  }
  /deep/p:first-child {
    display: inline;
  }
}
li {
  margin-bottom: 10px;
}
.answer1 {
  height: 40px;
  background: #d7f3ea;
  margin-top: 15px;
  /deep/img {
    display: block;
    max-width: 100% !important;
  }
}
.answer2 {
  height: 40px;
  background: #fae7e6;
  margin-top: 15px;
  /deep/img {
    display: block;
    max-width: 100% !important;
  }
}
.answer1 span {
  width: 79px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #32b387;
  line-height: 40px;
  margin-left: 18px;
  margin-right: 10px;
}
.answer2 span {
  width: 79px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ea7e7b;
  line-height: 40px;
  margin-left: 18px;
  margin-right: 10px;
}
.ansAnalysis {
  margin-top: 21px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 22px;
  word-break: break-all;
  margin-bottom: 40px;
  /deep/img {
    display: block;
    max-width: 100% !important;
  }
}
/deep/p:first-child {
  display: inline;
}
.all-question-outer /deep/ol {
  list-style: decimal !important;
  margin-left: 15px;
}
/deep/.selete ul,
/deep/.selete ol {
  display: inline-block;
}
/deep/.radioContent img,
/deep/.ansAnalysis img {
  max-width: 90% !important;
  display: block;
  margin-top: 5px;
}
/deep/.radioContent p {
  display: inline;
}
/deep/.selete {
  word-wrap: break-word;
  word-break: normal;
}
/deep/.ant-radio-wrapper {
  white-space: normal;
}
.score {
  color: #9a3bec;
  font-weight: normal;
}
.deleted {
  color: #ea7e7b;
  font-size: 16px;
}
.deleteImg {
  text-align: center;
  height: 475px;
  margin-top: 140px;
}
.getScore {
  margin-left: 50px;
  font-weight: normal;
}
</style>
<style>
.question .ant-radio-group .ant-radio-disabled + span {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #14202c;
  line-height: 32px;
}
.question .ant-radio-group .ant-radio-disabled .ant-radio-inner {
  background-color: #fff;
}
/* .question .ant-radio-group .ant-radio-checked .ant-radio-inner{
    border-color: #19BE94 !important;
}
.question .ant-radio-group .ant-radio-disabled .ant-radio-inner::after {
    background-color: #19BE94;
} */
</style>